var _defaultColor, _defaultSize;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { jsx, jsxs } from 'react/jsx-runtime';
import { memo, useRef } from 'react';
import cc from 'classcat';
import { useStore } from '@reactflow/core';
import shallow from 'zustand/shallow';
var BackgroundVariant;

(function (BackgroundVariant) {
  BackgroundVariant["Lines"] = "lines";
  BackgroundVariant["Dots"] = "dots";
  BackgroundVariant["Cross"] = "cross";
})(BackgroundVariant || (BackgroundVariant = {}));

function LinePattern(_ref) {
  var color = _ref.color,
      dimensions = _ref.dimensions,
      lineWidth = _ref.lineWidth;
  return jsx("path", {
    stroke: color,
    strokeWidth: lineWidth,
    d: "M".concat(dimensions[0] / 2, " 0 V").concat(dimensions[1], " M0 ").concat(dimensions[1] / 2, " H").concat(dimensions[0])
  });
}

function DotPattern(_ref2) {
  var color = _ref2.color,
      radius = _ref2.radius;
  return jsx("circle", {
    cx: radius,
    cy: radius,
    r: radius,
    fill: color
  });
}

var defaultColor = (_defaultColor = {}, _defineProperty(_defaultColor, BackgroundVariant.Dots, '#91919a'), _defineProperty(_defaultColor, BackgroundVariant.Lines, '#eee'), _defineProperty(_defaultColor, BackgroundVariant.Cross, '#e2e2e2'), _defaultColor);
var defaultSize = (_defaultSize = {}, _defineProperty(_defaultSize, BackgroundVariant.Dots, 1), _defineProperty(_defaultSize, BackgroundVariant.Lines, 1), _defineProperty(_defaultSize, BackgroundVariant.Cross, 6), _defaultSize);

var selector = function selector(s) {
  return {
    transform: s.transform,
    patternId: "pattern-".concat(s.rfId)
  };
};

function Background(_ref3) {
  var _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? BackgroundVariant.Dots : _ref3$variant,
      _ref3$gap = _ref3.gap,
      gap = _ref3$gap === void 0 ? 20 : _ref3$gap,
      size = _ref3.size,
      _ref3$lineWidth = _ref3.lineWidth,
      lineWidth = _ref3$lineWidth === void 0 ? 1 : _ref3$lineWidth,
      color = _ref3.color,
      style = _ref3.style,
      className = _ref3.className;
  var ref = useRef(null);

  var _useStore = useStore(selector, shallow),
      transform = _useStore.transform,
      patternId = _useStore.patternId;

  var patternColor = color || defaultColor[variant];
  var patternSize = size || defaultSize[variant];
  var isDots = variant === BackgroundVariant.Dots;
  var isCross = variant === BackgroundVariant.Cross;
  var gapXY = Array.isArray(gap) ? gap : [gap, gap];
  var scaledGap = [gapXY[0] * transform[2] || 1, gapXY[1] * transform[2] || 1];
  var scaledSize = patternSize * transform[2];
  var patternDimensions = isCross ? [scaledSize, scaledSize] : scaledGap;
  var patternOffset = isDots ? [scaledSize / 2, scaledSize / 2] : [patternDimensions[0] / 2, patternDimensions[1] / 2];
  return jsxs("svg", {
    className: cc(['react-flow__background', className]),
    style: _objectSpread(_objectSpread({}, style), {}, {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0
    }),
    ref: ref,
    children: [jsx("pattern", {
      id: patternId,
      x: transform[0] % scaledGap[0],
      y: transform[1] % scaledGap[1],
      width: scaledGap[0],
      height: scaledGap[1],
      patternUnits: "userSpaceOnUse",
      patternTransform: "translate(-".concat(patternOffset[0], ",-").concat(patternOffset[1], ")"),
      children: isDots ? jsx(DotPattern, {
        color: patternColor,
        radius: scaledSize / 2
      }) : jsx(LinePattern, {
        dimensions: patternDimensions,
        color: patternColor,
        lineWidth: lineWidth
      })
    }), jsx("rect", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      fill: "url(#".concat(patternId, ")")
    })]
  });
}

Background.displayName = 'Background';
var Background$1 = memo(Background);
export { Background$1 as Background, BackgroundVariant };